export const tailMisc = {
  tabBottom: {
    checkins: `Check-iny`,
    checkinsProg: `Nadchodzące`,
    requests: `Prośby`,
  },
  adminNav: {
    myAccount: `Moje konto`,
  },
  loader: {
    title: `Tworzymy: {reason}!`,
    defaultReason: `zakwaterowanie`,
    preparing: `Trwa przygotowywanie: {reason}. Proszę chwilę poczekać…`,
    calendar: `Konfigurowanie kalendarza`,
    availability: `Sprawdzanie dostępności`,
    prices: `Konfigurowanie cen`,
    almostDone: `Już prawie gotowe, finalizujemy: {reason}…`,
  },
};
